/* NilMarket — Interactive JS */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Mega menu — click to open/close ── */
  document.querySelectorAll('.nm-mega-trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const parent = trigger.closest('.nm-has-mega');
      const isOpen = parent.classList.contains('open');

      // Close all others first
      document.querySelectorAll('.nm-has-mega.open').forEach(el => el.classList.remove('open'));

      if (!isOpen) parent.classList.add('open');
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
      if (e.key === 'Escape') {
        trigger.closest('.nm-has-mega')?.classList.remove('open');
      }
    });
  });

  // Close mega on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.nm-has-mega.open').forEach(el => el.classList.remove('open'));
  });

  // Close on Escape key anywhere
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nm-has-mega.open').forEach(el => el.classList.remove('open'));
    }
  });

  /* ── Mobile menu toggle ── */
  const mobileToggle  = document.getElementById('nm-mobile-toggle');
  const mobileDrawer  = document.getElementById('nm-mobile-drawer');
  const mobileOverlay = document.getElementById('nm-mobile-overlay');
  const mobileClose   = document.getElementById('nm-mobile-close');

  function openDrawer()  {
    mobileDrawer?.classList.add('open');
    mobileOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    mobileToggle?.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    mobileDrawer?.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    document.body.style.overflow = '';
    mobileToggle?.setAttribute('aria-expanded', 'false');
  }

  mobileToggle?.addEventListener('click', openDrawer);
  mobileClose?.addEventListener('click', closeDrawer);
  mobileOverlay?.addEventListener('click', closeDrawer);

  /* ── Mobile accordion sub-menus ── */
  document.querySelectorAll('.nm-mobile-toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      const isOpen = sub.classList.contains('open');
      document.querySelectorAll('.nm-mobile-sub.open').forEach(el => el.classList.remove('open'));
      document.querySelectorAll('.nm-mobile-toggle-btn.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) {
        sub.classList.add('open');
        btn.classList.add('open');
      }
    });
  });

  /* ── Policy page UI enhancement ── */
  if (document.body.classList.contains('template-policy')) {
    const main = document.getElementById('main-content');
    if (!main) return;

    const title = main.querySelector('h1');
    const titleText = title ? title.textContent.trim() : '';
    let icon = '📄';
    if (/privacy|datenschutz/i.test(titleText)) icon = '🔒';
    else if (/refund|erstattung|return/i.test(titleText)) icon = '↩️';
    else if (/shipping|versand/i.test(titleText)) icon = '🚚';
    else if (/terms|agb|conditions/i.test(titleText)) icon = '📋';

    const style = document.createElement('style');
    style.textContent = `
      body.template-policy #main-content {
        background: #f8f4ee;
        padding: 3rem 1.5rem 5rem;
        min-height: 60vh;
      }
      .nm-pol-inner {
        max-width: 860px;
        margin: 0 auto;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 20px rgba(0,0,0,0.08);
        overflow: hidden;
      }
      .nm-pol-header {
        background: linear-gradient(135deg, #2d6a4f 0%, #1a5c3a 100%);
        padding: 2.5rem 3.5rem;
        text-align: center;
      }
      .nm-pol-icon { font-size: 2.5rem; margin-bottom: 0.75rem; }
      .nm-pol-header h1 {
        font-size: 2rem !important;
        color: #fff !important;
        margin: 0 !important;
        font-weight: 700;
      }
      .nm-pol-body {
        padding: 3rem 3.5rem;
        border-bottom: 1px solid #eee;
      }
      .nm-pol-body h2 {
        font-size: 1.1rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 2rem 0 0.5rem;
        padding-left: 0.75rem;
        border-left: 3px solid #c9a84c;
      }
      .nm-pol-body h3 { font-size: 1rem; font-weight: 600; color: #2d6a4f; margin: 1.25rem 0 0.4rem; }
      .nm-pol-body p { font-size: 0.92rem; line-height: 1.85; color: #555; margin-bottom: 0.75rem; }
      .nm-pol-body ul, .nm-pol-body ol { font-size: 0.92rem; line-height: 1.85; color: #555; padding-left: 1.5rem; margin-bottom: 0.75rem; }
      .nm-pol-body li { margin-bottom: 0.3rem; }
      .nm-pol-body a { color: #2d6a4f; text-decoration: underline; }
      .nm-pol-body strong { color: #1a1a1a; }
      .nm-pol-contact {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1.5rem 3.5rem;
        background: #f8f4ee;
      }
      .nm-pol-contact-icon { font-size: 1.75rem; flex-shrink: 0; }
      .nm-pol-contact strong { display: block; color: #1a1a1a; margin-bottom: 0.15rem; }
      .nm-pol-contact p { margin: 0; font-size: 0.9rem; color: #555; }
      .nm-pol-contact a { color: #2d6a4f; }
      @media (max-width: 640px) {
        .nm-pol-header { padding: 2rem 1.25rem; }
        .nm-pol-header h1 { font-size: 1.5rem !important; }
        .nm-pol-body { padding: 2rem 1.25rem; }
        .nm-pol-contact { padding: 1.25rem; flex-direction: column; text-align: center; }
      }
    `;
    document.head.appendChild(style);

    const inner = document.createElement('div');
    inner.className = 'nm-pol-inner';

    const header = document.createElement('div');
    header.className = 'nm-pol-header';
    header.innerHTML = `<div class="nm-pol-icon">${icon}</div>`;
    if (title) header.appendChild(title);

    const body = document.createElement('div');
    body.className = 'nm-pol-body';
    while (main.firstChild) body.appendChild(main.firstChild);

    const contact = document.createElement('div');
    contact.className = 'nm-pol-contact';
    contact.innerHTML = `
      <span class="nm-pol-contact-icon">✉️</span>
      <div>
        <strong>Questions about this policy?</strong>
        <p>Contact us at <a href="mailto:info@nilmarket.de">info@nilmarket.de</a></p>
      </div>
    `;

    inner.appendChild(header);
    inner.appendChild(body);
    inner.appendChild(contact);
    main.appendChild(inner);
  }

});
